import React from "react";

import { useDispatch } from "react-redux";

import { parseApiError } from "../../Helper/apiError.helper";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../Redux/Slices/alert.slice";
import { ListTable } from "../Table/listTable/listTable";
import { getValue } from "../../utils/object.utils";
import {
  useGetClasses,
  useRemoveClass,
} from "../../hooks/classHooks/class.hooks";
import { transformClassListTableData } from "../../Services/transformer/transformClassesListTableData";
import { classListsTitle } from "../../Constants/tableTitles/ListTableTitle/classList.titles";
import { EditClassModal } from "./EditClassModal";
import { RemoveClassModal } from "./RemoveClassModal";

export const ClassList = () => {
  const dispatch = useDispatch();

  const [openRemoveModal, setOpenRemoveModal] = React.useState<boolean>(false);
  const [openEditModal, setOpenEditModal] = React.useState<boolean>(false);

  const { isLoading: isClassesLoading, data: classes } = useGetClasses();

  const { isLoading: isRemoving, mutate: removeClass } = useRemoveClass({
    onSuccess: () => {
      dispatch(setSuccessMessage("Class removed successfully."));
      setOpenRemoveModal(false);
    },
    onError: (error: Error) => {
      dispatch(setErrorMessage(parseApiError(error)));
    },
  });

  const [selectedClassToRemove, setSelectedClassToRemove] =
    React.useState<any>(null);

  const [selectedClassToEdit, setSelectedClassToEdit] =
    React.useState<any>(null);

  const handleClassRemove = () => {
    const blockId = getValue(selectedClassToRemove, "id");

    if (!blockId) return null;

    removeClass(blockId);
  };

  return (
    <div>
      <ListTable
        titles={classListsTitle}
        data={classes}
        isDataLoading={isClassesLoading}
        transformFn={transformClassListTableData}
        moreOptons={{
          onEdit: (data: any) => {
            setSelectedClassToEdit(data);
            setOpenEditModal(true);
          },
          onRemove: (data: any) => {
            setSelectedClassToRemove(data);
            setOpenRemoveModal(true);
          },
        }}
      />
      <RemoveClassModal
        open={openRemoveModal}
        handleClassRemove={handleClassRemove}
        onClose={() => {
          setOpenRemoveModal(false);
        }}
        selectedClassToRemove={selectedClassToRemove}
        isProcessingConfirmation={isRemoving}
      />

      <EditClassModal
        open={openEditModal}
        selectedClass={selectedClassToEdit}
        onClose={() => {
          setOpenEditModal(false);
        }}
      />
    </div>
  );
};
